<template>
<div id="puzzle-upload">
  <form
    :action="this.apiUrl('/puzzles', true)"
    method="post"
    enctype="multipart/formdata"
    v-on:submit.prevent="submit"
  >
    <h4>Puzzle Details</h4>

    <div class="alert alert-warning text-center" role="alert">
      Additional options are available upon uploading the puzzle source file.
    </div>

    <puzzle-upload-file
      isRequired="true"
      v-on:source-file-not-player-compatible="ifSourceFileNotPlayerCompatible"
      v-on:source-file-player-compatible="ifSourceFilePlayerCompatible"
      v-on:puzzle-imported="onPuzzleImported"
    />

    <div
      v-if="sourceFileNotPlayerCompatible"
    >
      <hr />

      <p
        class="alert alert-danger text-center"
      >
        The puzzle source file is a print-only file.
        Please fill out the following information to upload it.
      </p>

      <div class="form-group">
        <label for="puzzle-name" class="form-label">
          Puzzle Name
        </label>

        <input
          class="form-control"
          type="text"
          id="puzzle-name"
          name="puzzles[name]"
          v-model="name"
          required="true"
        />
      </div>

      <div class="form-group">
        <label for="puzzle-author" class="form-label">
          Puzzle Author
        </label>

        <input
          class="form-control"
          type="text"
          id="puzzle-author"
          name="puzzles[author]"
          v-model="author"
          required="true"
        />
      </div>

      <div class="form-group">
        <label for="puzzle-width" class="form-label">
          Puzzle Width
        </label>

        <input
          type="number"
          id="puzzle-width"
          name="puzzles[width]"
          v-model="width"
          required="true"
        />

        <label for="puzzle-height" class="form-label">
          Puzzle Height
        </label>

        <input
          type="number"
          id="puzzle-height"
          name="puzzles[height]"
          v-model="height"
          required="true"
        />
      </div>
    </div>
    <fieldset
      class="imported-puzzle-data"
      v-else-if="importedPuzzle.title"
    >
      <legend>
        Imported Puzzle Data
      </legend>

      <table
        class=" table"
      >
        <td>
          Title
        </td>
        <td>
          {{ importedPuzzle.title }}
        </td>
      </table>
    </fieldset>

    <hr />

    <div class="form-group">
      <label for="puzzle-date" class="form-label">
        Puzzle Date
      </label>

      <input
        class="form-control"
        type="date"
        id="puzzle-date"
        name="puzzles[date]"
        v-model="date"
        required="true"
      />
    </div>

    <hr />

    <div class="form-group row">
      <div class="col-sm-2">
        <label for="puzzle-difficulty">
          Difficulty Level (Between 1-100)
        </label>
      </div>
      <div class="col-10">
        <input
          type="number"
          name="puzzles[difficulty]"
          id="puzzle-difficulty"
          class="form-control"
          v-model="difficulty"
        />
      </div>
    </div>

    <hr />

    <provider-picker
      label="Puzzle Type"
      selectName="puzzles[puzzle_link_id]"
      required
    />

    <hr />

    <div
      id="contributors"
    >
      <puzzle-editors-picker
        action="getAvailableContributors"
        inputName="puzzles[editor_ids][]"
        :selectedUserIds="editorIds"
        :suggestedUsers="suggestedUsers"
        usersLbl="Editors"
        v-on:users-changed="editorsChanged"
      />

      <puzzle-authors-picker
        action="getAvailableContributors"
        inputName="puzzles[author_ids][]"
        :selectedUserIds="authorIds"
        :suggestedUsers="suggestedUsers"
        usersLbl="Authors"
        v-on:users-changed="authorsChanged"
      />
    </div>

    <input
      type="hidden"
      name="puzzles[public]"
      value="true"
    />

    <button
      type="submit"
      class="btn btn-primary form-control"
    >
      Upload Puzzle
      <puzzle-upload-spinner size="small" v-if="loading"></puzzle-upload-spinner>
    </button>
  </form>
</div>
</template>

<script>

import Spinner from 'vue-simple-spinner'

import ProviderPicker from '@/components/ProviderPicker'
import PuzzleNav from '@/components/PuzzleNav'
import PuzzleUploadFile from '@/components/PuzzleUploadFile'
import UserPicker from '@/components/UserPicker'

import PuzzleStore from '@/stores/PuzzleStore'

export default {
  data () {
    let state = PuzzleStore.state
    state.source_file = undefined
    state.date = new Date()
    state.loading = false
    state.sourceFileNotPlayerCompatible = false
    state.importedPuzzle = {}

    return state
  },

  props: ['puzzleId', 'replace'],

  components: {
    'puzzle-authors-picker': UserPicker,
    'puzzle-editors-picker': UserPicker,
    'provider-picker': ProviderPicker,
    'puzzle-nav': PuzzleNav,
    'puzzle-upload-file': PuzzleUploadFile,
    'puzzle-upload-spinner': Spinner
  },

  computed: {
    authorIds () {
      return this.authors.map(author => author.id)
    },

    contributorIds () {
      return this.contributors.map(contributor => contributor.id)
    },

    editorIds () {
      return this.editors.map(editor => editor.id)
    },

    suggestedUsers () {
      return this.importedPuzzle.author ? [
        this.importedPuzzle.author
      ] : []
    }
  },

  methods: {
    ifSourceFileNotPlayerCompatible (fn) {
      this.sourceFileNotPlayerCompatible = true
    },

    ifSourceFilePlayerCompatible (fn) {
      this.sourceFileNotPlayerCompatible = false
    },

    onPuzzleImported (puzzle) {
      this.importedPuzzle = puzzle
    },

    authorsChanged (authorIds) {
      this.author_ids = authorIds
    },

    editorsChanged (editorIds) {
      this.editor_ids = editorIds
    },

    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false

        const puzzleId = response.body.data.id

        this.$router.push({
          name: 'puzzle',
          params: {
            puzzleId: puzzleId
          }
        })
      }, (resp) => {
        this.loading = false

        this.$parent.$parent.processErrors(resp)
      })
    }
  }
}
</script>
<style
  scoped
>
  #contributors {
    display: flex;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// src/components/PuzzleUpload.vue